import { render } from "./DetailScreen.vue?vue&type=template&id=c5279fa4"
import script from "./DetailScreen.vue?vue&type=script&lang=js"
export * from "./DetailScreen.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__